<div class="progress-bar-dialog">
  <div class="header">
    <div class="title">{{ title }}</div>
    <div class="rectangle"></div>
  </div>

  <div
    class="progress-style"
    [ngClass]="{
      'progress-style-default': type == Types.DEFAULT,
      'progress-style-upload': type == Types.UPLOAD
    }"
  >
    <mat-progress-bar class="bar" [mode]="'determinate'" [value]="progressValue$ | async"> </mat-progress-bar>
  </div>

  <div *ngIf="type === Types.UPLOAD" class="count">
    <span class="current-progress"> {{ currentProgress }} </span> von <span class="total-progress"> {{ progressGoal }} </span>
  </div>

  <div class="body">
    <div
      class="message"
      [innerHTML]="message"
      [ngClass]="{
        'message-default': type == Types.DEFAULT,
        'message-upload': type == Types.UPLOAD
      }"
    ></div>
    <div
      class="footer"
      [ngClass]="{
        'footer-default': type == Types.DEFAULT,
        'footer-upload': type == Types.UPLOAD
      }"
    >
      <button *ngIf="declineText" class="btn" (click)="goToDashboard()" [disabled]="type === Types.UPLOAD">{{ declineText }}</button>
    </div>
  </div>
</div>
